import axios from 'axios';

const env = process.env.NODE_ENV;
export let http = axios.create();
if (env === 'development') {
// для локальной разработки
    http = axios.create({
        // baseURL: 'http://nsk.svoe-stas.ru/',
        baseURL: 'http://127.0.0.1:8000/',
    });
} else {

}

// export const http = axios.create();
console.log('process.env: ', process.env);

export default http;
